import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import OrdersView from './view/OrdersView';
import OrdersDetails from './details/OrdersDetails';
import OrdersDetailsRightSidebar from './details/OrdersDetailsRightSidebar';

import buttons from './OrdersButtons';
import events from './OrdersEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('orders'),
	routes: [
		{
			path: 'orders/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'orders'),
			element: (
				<DetailsPage
					key="orders/add"
					module="orders"
					tabs={OrdersDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'orders/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'orders'),
			element: (
				<DetailsPage
					key="orders/details"
					module="orders"
					tabs={OrdersDetails}
					buttons={buttons.details}
					events={events}
					getRightSidebarSections={OrdersDetailsRightSidebar}
				/>
			)
		},
		{
			path: 'orders/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'orders'),
			element: (
				<ViewPage
					key="orders/view"
					module="orders"
					content={{ type: 'tabs', tabs: OrdersView }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
